import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { pageHref } from "../lib/format";
import Breadcrumbs from "../components/Breadcrumbs";
import { PageLoader } from "../components/States";

export default function SiteIndex() {
  const [groups, setGroups] = useState(null);

  useEffect(() => {
    api
      .get("/sitemap-index")
      .then((r) => setGroups(r.data.groups || []))
      .catch(() => setGroups([]));
  }, []);

  const total = (groups || []).reduce((a, g) => a + g.pages.length, 0);

  return (
    <div data-testid="site-index-page">
      <section className="border-b" style={{ borderColor: "rgba(255,255,255,0.08)", background: "var(--nq-ink)" }}>
        <div className="container-nq py-10">
          <Breadcrumbs items={[{ slug: "site-index", label: "Site index" }]} />
          <p className="eyebrow mt-4">Every page</p>
          <h1 className="mt-2 text-3xl font-bold md:text-5xl">Site index</h1>
          {total > 0 && (
            <p className="mt-3 text-sm text-[color:var(--nq-stone)]">
              {total} pages across {groups.length} sections
            </p>
          )}
        </div>
      </section>

      <div className="container-nq section-nq">
        {!groups ? (
          <PageLoader />
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {groups.map((g) => (
              <section key={g.section} className="card-nq p-5" data-testid="site-index-group">
                <h2 className="text-sm font-bold uppercase tracking-wider gold-text">
                  {g.section}
                  <span className="ml-2 font-mono text-xs font-normal text-[color:var(--nq-stone)]">
                    {g.pages.length}
                  </span>
                </h2>
                <ul className="mt-3 space-y-1">
                  {g.pages.map((p) => (
                    <li key={p.slug}>
                      <Link
                        to={pageHref(p.slug)}
                        className="flex min-h-[40px] items-center truncate rounded px-2 py-2 text-sm text-[color:var(--nq-stone)] transition hover:bg-white/5 hover:text-[color:var(--nq-gold)] sm:min-h-0 sm:py-1"
                        data-testid="site-index-link"
                      >
                        {p.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
